import { waitForContent } from "../shared/utility";
import { initializePage } from "../shared/page-init";
import { validatePage } from "../shared/validation";
import { previous } from "../shared/navigation";
import { renderNavButtons, renderQuestionOkLow } from "../shared/templates.js";

const app = window.app;

export class Fluids extends HTMLElement {
	async connectedCallback() {
		await waitForContent("fluids");
		this.innerHTML = app.content.fluids;

		this.querySelector("#nav-slot").replaceWith(renderNavButtons("backButton7", "nextButton7"));

		const questions = [
			["fluid-oil",      "Engine oil level"     ],
			["fluid-steering", "Power steering fluid"  ],
			["fluid-brake",    "Brake fluid"           ],
			["fluid-coolant",  "Coolant"               ],
			["fluid-washer",   "Washer fluid"          ],
			["fluid-def",      "DEF fluid"             ],
		];

		for (const [name, label] of questions) {
			this.querySelector(`#${name}-slot`).replaceWith(renderQuestionOkLow(name, label, 7));
		}

		this.addEventListener("ionViewWillEnter", async () => {
			const pageElement = this;
			await initializePage(7, pageElement);
		});
		this.addEventListener("ionViewDidEnter", async () => {
			const currentRoute = app.routes.fluids;
			const nextPage = app.flowManager.getNext(currentRoute);
			const prevPage = app.flowManager.getPrevious(currentRoute);

			if (prevPage) app.state.backButton.addEventListener("click", () => previous(prevPage.route));
			if (nextPage) app.state.nextButton.addEventListener("click", () => validatePage(nextPage.route));
		});
	}
}
